// extracted by mini-css-extract-plugin
export default {"main":"Subcategory_main__kJhRe","title":"Subcategory_title__JEJAw"};